import { api } from 'app/api';
import { selectSelectedEnvId } from 'app/containers/HiikoEnv/slice/selectors';
import { selectRoutesWithoutTaskFilters } from 'app/containers/Task/slice/selectors';
import { useSelector } from 'react-redux';

export const useGetRoutesWithoutTaskFromState = () => {
  const envId = useSelector(selectSelectedEnvId) as number;
  const filters = useSelector(selectRoutesWithoutTaskFilters);

  const {
    data: routesData,
    isFetching: isRoutesFetching,
  } = api.endpoints.getRoutes.useQueryState({
    envId,
    filters,
    routesInFieldsOnly: true,
  });
  const routes = routesData?.content || [];

  return { routes, isRoutesFetching };
};
